import Util from '../Util';

class RoleAction {
  constructor(obj = {}) {
    this.id = obj.id;
    this.role = obj.role;
    this.context = obj.context;
    this.description = obj.description;
    this.menupage = obj.menupage;
    this.controller = obj.controller;
    this.action = obj.action;
    this.isDisabled = obj.isDisabled;
  }

  toPlainObject() {
    let obj = {};
    let keys = Object.keys(this);
    for (let k of keys) {
      switch (k) {
        default:
          obj[k] = this[k];
      }
    }
    return obj;
  }
}

export default RoleAction;



// WEBPACK FOOTER //
// ./src/model/SosdbRoleAction.js